<template>
    <!-- section 1 -->
    <section class=" flexmobile2 mt-44 mx-auto px-20">
    <section class="flex flexmobile2 flex-col items-start text-3xl  text-rose-300">
      <p class="text-red-300 text-2xl md:text-3xl font-semibold pt-6">Real time updates</p>
      <div class="flex flexmobile2 flex-col mt-8  w-full  max-w-[1194px] max-md:mt-10 max-md:max-w-full">
        <p class="pt-6 text-lg md:pb-6 text-white  max-md:max-w-full">
          Users are kept informed on the status of their orders starting from preparation to pickup or delivery.
        </p>
        <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/77533821a34216cd493cbef7e2936aa2f806a02a3b9b5b5a4b42458ab479d659?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="Real-time order status updates visualization" class="object-contain self-end mt-12 w-full aspect-[1.87]  max-md:mt-10 max-md:max-w-full" />
      </div>
      <p class="text-red-300 text-2xl md:text-3xl font-semibold pt-6">Streamlined Payment Process</p>
      <div class="flex flexmobile2 flex-col max-md:max-w-full mt-4">
        <p class="self-start pt-6 text-lg md:pb-6 text-white max-md:max-w-full">
          The app allows users to opt-in to save their card details. This helps recurring users to save time and expedites the ordering experience
        </p>
        <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/3804bf1fd0b1b3d078bd1d9ba565dcc2ed590d95073bdb585001c63ad00fea0c?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="Streamlined payment process illustration" class="object-contain self-center mt-6 ml-6 max-w-full aspect-[0.93] w-[572px]" />
      </div>
    </section>
    </section>
    <!-- section 2 -->
    <section class=" flexmobile2 mt-32 mx-auto px-20">
    <div>
        <h1 class="self-start text-4xl font-semibold text-white">Sketches/Low-Fidelity Wireframes</h1>
    </div>
    <div class="mt-16">
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726833737/Group_34218_ej3zib.png" alt="">
    </div>
    </section>
    <!-- section 3 -->
    <section class=" flexmobile2 mx-auto px-20 mt-32">
    <div>
        <h1 class="self-start text-4xl font-semibold text-white">High-Fidelity Wireframes</h1>
    </div>
    <div>
        <p class="text-red-300 text-3xl pt-6  mt-10 font-semibold dancing-script ml-24 -pb-12">Welcome Screen</p>
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726670150/Group_34199_n9oa1l.png" alt="">
        <p class="text-red-300 text-2xl md:text-3xl font-semibold pt-6">Light mode Screens </p>
    </div>
    </section>
    <!-- section 4 -->
    <section class="flexmobile2 mx-auto px-20 mt-16">
    <div>
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726833778/Group_34219_gktq9i.png" alt="">
    </div>
    </section>
    <!-- section 5 -->
    <section class=" flexmobile2 mx-auto px-20 mt-32" >
        <div>
            <p class="text-red-300 text-2xl md:text-3xl font-semibold pt-6">Dark mode Screens </p>
        </div>
        <div class=" w-6xl md:mt-16 flex flex-col justify-center items-center">
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726670329/Group_34200_pfh89e.png" alt="">
        
        <a
            href="https://www.figma.com/proto/dxMfS7oM2YNIKumZBWBDIp/french-bakery?node-id=833-632&node-type=canvas&t=NFycSnicZ1MCT0k7-1&scaling=scale-down&content-scaling=fixed&page-id=728%3A527&starting-point-node-id=833%3A632&show-proto-sidebar=1"
              class="flex  max-w-96 relative p-10  bgColorr md:mb-20 top-2 md:mt-24 mt-20  md:w-46 h-12 text-center text-xl rounded-[80px] shadow-[0px_4px_24px_rgba(0,0,0,0.5)]"
            >
              <span class="grow text-white relative md:mt-0  bottom-4 text-center ">Checkout the Prototype</span>
            </a>
      </div>
      </section>
    <!-- section 6 -->
    <section class="container  flexmobile2 md:mt-40 mx-auto px-20 ">
        <div class="flex flexmobile justify-center">
        </div>
        <section class=" flex  relative  justify-center flex-col flex-wrap ">
        <h2 class="md:text-4xl text-xl text-center font-semibold text-white">View other Projects</h2>
        <div class="self-start mt-2 ml-4 max-md:max-w-full">
          <div class="flex justify-center  gap-5 max-md:flex-col">
            <article class="flex   w-full max-md:ml-0 max-md:w-full">
              <div class="pb-12 flex flex-col md:flex-row justify-between items-center font-bold text-white rounded-[50px] max-md:px-5 max-md:mt-10 max-md:max-w-full">
                <router-link to="NextProject">
        <div class="flex cursor-pointer relative md:mt-20 z-10 w-full max-w-full max-md:w-full max-md:h-auto ">
            <img loading="lazy" class="w-full h-full object-cover" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726864991/Group_34207_1_t8ptsv.png" alt="">
        </div>
    </router-link>
                <router-link to="WangosProject">
        <div class="flex cursor-pointer  relative z-10 w-full max-w-full max-md:w-full max-md:h-auto">
            <img loading="lazy" class="w-full h-full object-cover" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726678071/Group_34202_jsapnl.png" alt="">
        </div>
    </router-link>
    
</div>
            </article>
          </div>
        </div>
      </section>
    </section>
  </template>
  
  <script>
  export default {
    name: 'BakeryAppThree'
    
  }
  </script>